import React from "react"
import { MenuItem, TextField } from "@mui/material"

import FileInput from "../../../UI/FileInput"
import Button from "../../../UI/Button"
import Preloader from "../../../UI/Preloader"

const BRANCH_OPTIONS = [
  {
    value: "LEGACY",
    label: "Legacy",
    description: "For iOS and old Android builds",
  },
  {
    value: "V2",
    label: "V2",
    description: "For the updated Android app (new firmware protocol)",
  },
]

export const Form = (props) => {
  const {
    values: { fileName, currentVersion, newVersion, branch },
    errors,
    touched,
    isValid,
    setFieldValue,
    handleSubmit,
    handleChange,
    loading,
    errorsApi,
    onBranchChange,
  } = props

  const onFileSelect = (e) => {
    const fileNameValue = e.target.files[0] ? e.target.files[0].name : ""
    setFieldValue("fileName", fileNameValue)
    setFieldValue("file", e.target.files[0])
  }

  const onBranchSelect = (e) => {
    const value = e.target.value
    setFieldValue("branch", value)
    if (onBranchChange) {
      onBranchChange(value)
    }
  }

  const selectedBranch = BRANCH_OPTIONS.find((option) => option.value === branch)

  return (
    <form onSubmit={handleSubmit}>
      <TextField
        id="branch"
        name="branch"
        select
        label="Branch"
        variant="standard"
        style={{ marginBottom: "14px" }}
        className="auth_input"
        helperText={selectedBranch ? selectedBranch.description : ""}
        value={branch}
        onChange={onBranchSelect}
      >
        {BRANCH_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        id="currentVersion"
        name="currentVersion"
        label="Current version"
        variant="standard"
        style={{ marginBottom: "14px" }}
        className="auth_input"
        helperText={touched.currentVersion ? errors.currentVersion : ""}
        error={touched.currentVersion && Boolean(errors.currentVersion)}
        value={currentVersion}
        disabled
      />
      <FileInput fileName={fileName} onChange={(e) => onFileSelect(e)} />
      {Boolean(errorsApi) && (
        <p className="auth_errors">
          {errorsApi.data.message || errorsApi.data.msg}
        </p>
      )}
      <TextField
        id="newVersion"
        name="newVersion"
        label="New version"
        variant="standard"
        style={{ marginBottom: "33px" }}
        className="auth_input"
        helperText={touched.newVersion ? errors.newVersion : ""}
        error={touched.newVersion && Boolean(errors.newVersion)}
        onChange={handleChange}
        value={newVersion}
        disabled={!fileName}
      />
      <Button
        className="button"
        type="submit"
        color="primary"
        style={{ minWidth: "300px", marginBottom: "24px" }}
        disabled={!isValid || loading || !fileName}
      >
        {loading ? <Preloader mini /> : "Start updating"}
      </Button>
    </form>
  )
}
